import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Heart, Headphones, Package } from "react-feather";
import { styled } from "@mui/material/styles";
import Link from "next/link";

const HoverBox = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  cursor: "pointer",
  color: "#fff",
  border: "none",
  marginBottom: 20,
  height: 280,
  backgroundColor: "#31384b",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "40px 35px",
  "&::before, &::after": {
    content: '""',
    position: "absolute",
    left: 0,
    height: "2px",
    width: "100%",
    backgroundColor: "#fff",
    transformOrigin: "left",
    transform: "scaleX(0)",
    transition: "transform 0.5s, background-color 0.5s",
  },
  "&::before": {
    top: 0,
  },
  "&::after": {
    bottom: 0,
  },
  "&:hover": {
    backgroundColor: "#fff !important",
    color: "#3a3973",
    "&::before, &::after": {
      transform: "scaleX(1)",
      backgroundColor: "#31384b",
    },
    "& svg": {
      color: "#3a3973",
    },
  },
}));

const Introduction = () => {
  const { t } = useTranslation();

  return (
    <Container
      maxWidth="lg"
      disableGutters
      style={{ paddingTop: 60, paddingBottom: 60 }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Link href={"https://"} passHref>
            <HoverBox style={{ backgroundColor: "#31384b" }}>
              <Box>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Package
                    size={26}
                    style={{ marginRight: 15, marginBottom: 15 }}
                  />
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      marginBottom: 12,
                    }}
                  >
                    {t("introduction")}
                  </Typography>
                </Box>
                <Box style={{ textAlign: "justify", fontSize: 14 }}>
                  {t("introDescription")}
                </Box>
              </Box>
            </HoverBox>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <HoverBox style={{ backgroundColor: "#035dab" }}>
            <Box>
              <Box style={{ display: "flex", alignItems: "center" }}>
                <Heart
                  size={26}
                  style={{ marginRight: 15, marginBottom: 10 }}
                />
                <Typography
                  variant="h6"
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    marginBottom: 12,
                  }}
                >
                  {t("mission")}
                </Typography>
              </Box>
              <Box style={{ textAlign: "justify", fontSize: 14 }}>
                {t("missionDescription")}
              </Box>
            </Box>
          </HoverBox>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <HoverBox style={{ backgroundColor: "#209477" }}>
            <Box>
              <Box style={{ display: "flex", alignItems: "center" }}>
                <Headphones
                  size={26}
                  style={{ marginRight: 15, marginBottom: 15 }}
                />
                <Typography
                  variant="h6"
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    marginBottom: 12,
                  }}
                >
                  {t("organization")}
                </Typography>
              </Box>
              <Box style={{ textAlign: "justify", fontSize: 14 }}>
                {t("organDescription")}
              </Box>
            </Box>
          </HoverBox>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Introduction;
